import React from 'react';
import aboutimg from './assets/about.png';

function ProjectAbout() {
  return (
    <div>
      <h2>about</h2>
      <img 
        src={aboutimg} 
        alt="Weirdo" 
        style={{ 
          width: '100%', 
          maxWidth: 720, 
          display: 'block',
          height: 'auto' 
        }} 
      />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '15px' }}>
        <a href="https://x.com/F___T___W" style={{ color: 'rgb(170, 170, 170)', textDecoration: 'underline', fontStyle: 'italic' }} target="_blank" rel="noopener noreferrer">twitter</a>
        <span style={{ color: 'rgb(170, 170, 170)' }}>-</span>
        <a href="https://discord.com/invite/4pz9wZx6Xt" style={{ color: 'rgb(170, 170, 170)', textDecoration: 'underline', fontStyle: 'italic' }} target="_blank" rel="noopener noreferrer">discord</a>
        <span style={{ color: 'rgb(170, 170, 170)' }}>-</span>
        <a href="https://memedepot.com/d/ftw" style={{ color: 'rgb(170, 170, 170)', textDecoration: 'underline', fontStyle: 'italic' }} target="_blank" rel="noopener noreferrer">memes</a>
      </div>
    </div>
  );
}

export default ProjectAbout; 